import {gql} from "@apollo/client";

const CLUBMATE_EVENTS_LIST=gql`
subscription userEventsList {
  clubmate_entrance_clubmatereservation(order_by: {datetime: desc}) {
    id
    datetime
    clubmateservice_clubmateservice {
      id
      name
    }
    usersregister_userregister {
      id
      name
      surname
      fiscal_code
    }
  }
}
`

export {CLUBMATE_EVENTS_LIST};